// The self-serve paywalls are dev-only until launch. Production keeps the
// pre-paywall behaviour: the TrustCall demo modal and the direct remediation
// request. Compliance Guide has its own paywall and is unaffected.
export const SHOW_PAYWALLS = import.meta.env.VITE_APP_ENV !== "production";
